import { createMovieClip } from "../../../../common/functions/Functions_General";

class expandAnimationFrame {
  private parent: PIXI.Container = new PIXI.Container();
  private animation: PIXI.extras.AnimatedSprite = createMovieClip(
    "postExpandAnim",
    0,
    10
  );

  constructor(parent:PIXI.Container) {
    parent.addChild(this.parent);
    this.parent.addChild(this.animation);
    this.animation.blendMode = PIXI.BLEND_MODES.ADD;
    this.animation.anchor.set(0.5);
    this.animation.x = 0; //this.animation.width/2;
    this.animation.y = 0; //this.animation.height/2;
    this.animation.loop = true;
    this.animation.gotoAndPlay(0);
    this.play(false);
  }
  public getParent = (): PIXI.Container => {
    return this.parent;
  };

  public setNewTint = (newTint:number): void => {
     this.animation.tint= newTint;
  };

  public play = (bool: boolean): void => {

    this.parent.alpha = bool ? 1 : 0;
    if (bool) {
      if (this.animation.playing == false) {
        this.animation.gotoAndPlay(0);
        this.parent.alpha=1;
      }
    } else {
        this.parent.alpha=0
      this.animation.stop();
    }
  };
}
export class PostExpandAnimationPillar {
  private parent: PIXI.Container = new PIXI.Container();
  private suspenseFrames: Array<expandAnimationFrame>;

  constructor(
    parent: PIXI.Container,
    totalCol: Number,
    firstFramePosition: Array<number>,
    offsetX: number
  ) {
    parent.addChild(this.parent);
    this.suspenseFrames = [];
    for (let i = 0; i < totalCol; i++) {
      this.suspenseFrames[i] = new expandAnimationFrame(this.parent);
      this.suspenseFrames[i].getParent().x =
        firstFramePosition[0] + i * offsetX;
      this.suspenseFrames[i].getParent().y = firstFramePosition[1];
    }
  }
  public setScaleFrame = (newScale: Array<number>): void => {
    for (let i = 0; i < this.suspenseFrames.length; i++) {
      this.suspenseFrames[i].getParent().scale.set(newScale[0], newScale[1]);
    }
  };
  public clearAll = (): void => {
    for (let i = 0; i < this.suspenseFrames.length; i++) {
      this.clearSelected(i);
    }
  };
  public clearSelected = (index: number): void => {
    this.suspenseFrames[index].play(false);
  };
  public playSelected = (index: number): void => {
    this.suspenseFrames[index].play(true);
  };
  public playSelectedReel = (index: number): void => {
    if(index+1<=this.suspenseFrames.length)
    {
        this.suspenseFrames[index].play(true);   
        this.suspenseFrames[index+1].play(true);   
    }
    

  };
  public setTint=(newTint:number):void=>
  {
    for (let i = 0; i < this.suspenseFrames.length; i++) {
        this.suspenseFrames[i].setNewTint(newTint);
      }
  }
}
